import styled from "styled-components";

export const Title = styled("div")`
  font-size: 1.4rem;
  background-color: #f9f9f9;
  margin: 20px 0;
`;
